import React from 'react';
import { Section } from './ui/Section';
export function InstructorTestimonials() {
  const testimonials = [{
    quote: 'Llevaba años enseñando por intuición. Con los tomos por fin tengo un sistema real.',
    text: 'Llevaba años enseñando por intuición. Con los tomos por fin tengo un sistema real. Mis alumnos avanzan el doble de rápido y yo llego a clase sin estrés. Vale muchísimo más de lo que cuesta.',
    author: 'María García',
    initials: 'MG',
    role: 'Instructora de Sevillanas — Academia Flamenca',
    location: '📍 Sevilla, España'
  }, {
    quote: 'El Syllabus de 12 semanas me cambió la vida.',
    text: 'El Syllabus de 12 semanas me cambió la vida. Antes pasaba el domingo entero planificando. Ahora abro el PDF y en 5 minutos sé exactamente qué voy a enseñar. Increíble.',
    author: 'Carmen Rodríguez',
    initials: 'CR',
    role: 'Profesora Autónoma de Sevillanas',
    location: '📍 Madrid, España'
  }, {
    quote: 'Las fichas de seguimiento me ayudaron a detectar a tiempo a tres alumnas.',
    text: 'Las fichas de seguimiento me ayudaron a detectar a tiempo a tres alumnas que estaban a punto de irse. Las recuperé con el protocolo del manual. Ahora siguen en clase y me han traído dos amigas cada una.',
    author: 'Isabel Sánchez',
    initials: 'IS',
    role: 'Directora de Academia de Baile',
    location: '📍 Málaga, España'
  }, {
    quote: 'El tomo de braceo es una obra maestra.',
    text: 'El tomo de braceo es una obra maestra. Nunca nadie me había explicado que el braceo nace en el esternón. Desde que lo aplico en clase mis alumnas tienen una elegancia completamente diferente.',
    author: 'Laura Pérez',
    initials: 'LP',
    role: 'Instructora de Sevillanas y Flamenco',
    location: '📍 Córdoba, España'
  }, {
    quote: 'El SALA LLENA 365D es lo que necesitaba.',
    text: 'El SALA LLENA 365D es lo que necesitaba. Calculé mi precio real por primera vez y descubrí que estaba cobrando un 30% menos de lo que debería. Ahora tengo mis tarifas correctas y más alumnos que antes.',
    author: 'Ana Martínez',
    initials: 'AM',
    role: 'Instructora Autónoma',
    location: '📍 Valencia, España'
  }, {
    quote: 'Llevo 12 años dando clases y nunca había tenido un material tan completo.',
    text: 'Llevo 12 años dando clases y nunca había tenido un material tan completo en español. Los copis de marketing me han llenado el grupo de septiembre en dos semanas. Inversión 100% recomendada.',
    author: 'Rocío Castillo',
    initials: 'RC',
    role: 'Fundadora de Academia de Sevillanas',
    location: '📍 Granada, España'
  }];
  const scrollToPricing = () => {
    const el = document.getElementById('pricing');
    if (el) {
      const top = el.getBoundingClientRect().top + window.pageYOffset;
      window.scrollTo({
        top,
        behavior: 'smooth'
      });
    }
  };
  return <Section data-id="element-146">
      <h2 className="text-3xl md:text-4xl font-bold text-center mb-3 text-brand-title" data-id="element-147">
        🌍 Instructoras de toda España
      </h2>
      <p className="text-center text-brand-subtitle font-heading font-semibold mb-2" data-id="element-148">
        Lo que dicen las instructoras que ya lo usan
      </p>
      <p className="text-center text-brand-textMuted mb-8 text-sm tracking-wide font-body" data-id="element-149">
        Más de 500 instructoras ya están usando el Sistema en sus academias
      </p>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4 max-w-6xl mx-auto mb-8" data-id="element-150">
        {testimonials.map((testimonial, i) => <div key={i} className="bg-white border border-brand-border rounded-2xl p-5 shadow-card hover:shadow-card-hover transition-all" data-id="element-151">
            <div className="flex text-brand-cta text-sm mb-2" data-id="element-152">⭐⭐⭐⭐⭐</div>
            <h3 className="font-heading font-bold text-brand-subtitle mb-2 text-base" data-id="element-153">
              "{testimonial.quote}"
            </h3>
            <p className="font-body text-brand-text text-sm mb-3 leading-relaxed italic" data-id="element-154">
              {testimonial.text}
            </p>
            <div className="border-t border-brand-border pt-3" data-id="element-155">
              <div className="flex items-center gap-3 mb-2" data-id="element-156">
                <div className="w-10 h-10 rounded-full bg-brand-bgAlt flex items-center justify-center font-heading font-bold text-brand-title border border-brand-borderAccent text-sm" data-id="element-157">
                  {testimonial.initials}
                </div>
                <div data-id="element-158">
                  <p className="font-heading font-semibold text-brand-subtitle text-sm" data-id="element-159">
                    {testimonial.author}
                  </p>
                  <p className="font-body text-brand-textMuted text-xs" data-id="element-160">
                    {testimonial.role}
                  </p>
                </div>
              </div>
              <p className="font-body text-brand-textMuted text-xs" data-id="element-161">
                {testimonial.location}
              </p>
            </div>
          </div>)}
      </div>
    </Section>;
}